var vymena_klic = "";
var vymena_vysledek = "";
var vymena_odesilani = false;

function vymena_viditelnost(element, zobrazit)
{
	$(element)
		.toggle(zobrazit)
		.find("input")
			.prop("disabled", !zobrazit);
}

function vymena_zobrazit(element)
{
	vymena_viditelnost(element, true);
}

function vymena_skryt(element)
{
	vymena_viditelnost(element, false);
}

function vymena_zmenit(element)
{
	var name = element.attr("name");
	var value = element.val();
	vymena_skryt("#vymenaOdkaz, #vymenaIkonka, #vymenaOdkudSoubor, #vymenaOdkudWeb");
	switch (name)
	{
		case "typ":
			switch (value)
			{
				case "ikonka":
					vymena_zobrazit("#vymenaIkonka");
					vymena_zmenit($("#vymenaOdkudSouborRadio:checked, #vymenaOdkudWebRadio:checked"));
					break;
				case "odkaz":
					vymena_zobrazit("#vymenaOdkaz");
					break
			}
			break;
		case "odkud":
			vymena_zobrazit("#vymenaIkonka");
			switch (value)
			{
				case "soubor":
					vymena_zobrazit("#vymenaOdkudSoubor");
					break;
				case "web":
					vymena_zobrazit("#vymenaOdkudWeb");
					break
			}
			break
	}
}

function vymena_odeslat()
{
	if (vymena_odesilani) return false;
	var chyby = new Array;
	var elementChyby = $("#vymenaChyby");
	var web = $("#vymenaWeb").val();
	var popisek = $("#vymenaPopisek").val();
	var cislo = $("#vymenaCislo").val();
	var typ = $("#vymenaTypIkonka:checked, #vymenaTypOdkaz:checked").val();
	var odkud = $("#vymenaOdkudSouborRadio:checked, #vymenaOdkudWebRadio:checked").val();
	var ajax = {
		url: "/ajax/vymena.php",
		dataType: "json",
		type: "POST",
		data: { web: web, popisek: popisek, cislo: cislo, klic: vymena_klic, vysledek: vymena_vysledek },
		timeout: 3E4,
		beforeSend: function () {
			vymena_odesilani = true;
			elementChyby.html('<div class="alert alert-info">Prob\u00edh\u00e1 odes\u00edl\u00e1n\u00ed...</div>\n')
		},
		success: function (data) {
			vymena_odesilani = false;
			if (!data["status"] || data["status"] == "error" || data["status"] != "ok") if (data["error"]) elementChyby.html(data["error"]);
			else elementChyby.html('<div class="alert alert-warning">P\u0159i odes\u00edl\u00e1n\u00ed nastala bl\u00ed\u017ee neur\u010den\u00e1 chyba.</div>\n');
			else
			{
				elementChyby.html('<div class="alert alert-success">Formul\u00e1\u0159 byl \u00fasp\u011b\u0161n\u011b odesl\u00e1n.</div>\n');
				$("#vymenaWeb").val("");
				$("#vymenaPopisek").val("");
				$("#vymenaSoubor").val("");
				$("#vymenaAdresa").val("");
				$("#vymenaText").val("");
				$("#vymenaCislo").val("");
				setTimeout(function () {elementChyby.html("")}, 4E3)
			}
			if (data["captcha"])
			{
				vymena_vysledek = data["captcha"]["vysledek"];
				vymena_klic = data["captcha"]["klic"];
				$("#vymenaCaptcha")
					.attr("src", "/images/captcha.php?kod=" + encodeURIComponent(data["captcha"]["priklad"]) + "&klic=" + encodeURIComponent(vymena_klic));
				$("#vymenaCislo").val("")
			}
		},
		error: function (xhr, status) {
			vymena_odesilani = false;
			switch (status)
			{
				case "timeout":
					elementChyby.html('<div class="alert alert-warning">Vypr\u0161el \u010dasov\u00fd limit odes\u00edl\u00e1n\u00ed.</div>\n');
					break;
				case "abort":
					elementChyby.html('<div class="alert alert-warning">Odes\u00edl\u00e1n\u00ed bylo p\u0159eru\u0161eno.</div>\n');
					break;
				default:
					elementChyby.html('<div class="alert alert-warning">P\u0159i odes\u00edl\u00e1n\u00ed nastala bl\u00ed\u017ee neur\u010den\u00e1 chyba.</div>\n');
					break
			}
		}
	};
	if (!web) chyby[1] = "Adresa webu nebyla vypln\u011bna.";
	if (cislo.length < 1) chyby[3] = "P\u0159\u00edklad nebyl vypo\u010d\u00edt\u00e1n.";
	var pokracovat = true;
	switch (typ)
	{
		case "ikonka":
			switch (odkud)
			{
				case "soubor":
					if (!$("#vymenaSoubor").val()) chyby[2] = "Soubor nebyl vybr\u00e1n.";
					else if (window.FileReader)
					{
						var file = $("#vymenaSoubor")[0].files[0];
						if (file.size > 5E4) chyby[2] = "Soubor m\u016f\u017ee m\u00edt maxim\u00e1ln\u011b 50 kB.";
						else if (file.type != "image/gif" && file.type != "image/png" && file.type != "image/jpeg") chyby[2] =
							"Soubor m\u016f\u017ee b\u00fdt pouze typu GIF, PNG nebo JPG.";
						else
						{
							pokracovat = false;
							var reader = new FileReader;
							reader.onload = function (event) {
								ajax["data"]["soubor"] = event.target.result;
								if (chyby.length > 0)
								{
									elementChyby.html("");
									for (chyba in chyby) elementChyby.append('<div class="alert alert-warning">' + chyby[chyba] + "</div>\n")
								}
								else $.ajax(ajax)
							};
							reader.readAsDataURL(file, "UTF-8")
						}
					}
					else chyby[2] = "V\u00e1\u0161 prohl\u00ed\u017ee\u010d nepodporuje t\u0159\u00eddu FileReader, proto nem\u016f\u017ee b\u00fdt soubor nahr\u00e1n.";
					break;
				case "web":
					var adresa = $("#vymenaAdresa").val();
					if (!adresa) chyby[2] = "Adresa ikonky nebyla vypln\u011bna.";
					else ajax["data"]["adresa"] = adresa;
					break
			}
			break;
		case "odkaz":
			var text = $("#vymenaText").val();
			if (!text) chyby[2] = "Text odkazu nebyl vypln\u011bn.";
			else ajax["data"]["text"] = text;
			break
	}
	if (pokracovat) if (chyby.length > 0)
	{
		elementChyby.html("");
		for (chyba in chyby) elementChyby.append('<div class="alert alert-warning">' + chyby[chyba] + "</div>\n")
	}
	else $.ajax(ajax)
}

$(document).ready(function () {
	$("#vymenaTypIkonka, #vymenaTypOdkaz").change(function () {vymena_zmenit($(this))});
	$("#vymenaOdkudSouborRadio, #vymenaOdkudWebRadio").change(function () {vymena_zmenit($(this))})
});
